import { render, staticRenderFns } from "./production_cart.vue?vue&type=template&id=be4f1f98&"
import script from "./production_cart.vue?vue&type=script&lang=js&"
export * from "./production_cart.vue?vue&type=script&lang=js&"
import style0 from "./production_cart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports